import { Component } from '@angular/core';
import { KENDO_GRIDLAYOUT } from '@progress/kendo-angular-layout';

@Component({
  selector: 'unity-page-return-layout',
  imports: [KENDO_GRIDLAYOUT],
  templateUrl: './page-return-layout.html',
  styleUrl: './page-return-layout.scss',
})
export class PageReturnLayout {}
